/**
 * CRUD de propostas comerciais.
 * Coleção: propostas/{id}
 * Dados do documento armazenados como JSON; PDF renderizado no cliente sob demanda.
 * Uma proposta referencia um "sujeito": lead OU cliente ativo (subjectType).
 */

function msOf(ts) {
  if (!ts) return 0;
  if (typeof ts === 'number') return ts;
  if (typeof ts.toDate === 'function') return ts.toDate().getTime();
  return 0;
}

/** Subscrição global — volume baixo; filtragem por lead/cliente é feita em memória na UI. */
export function subscribeAllPropostas(callback) {
  const db = window._fbDb;
  if (!db || !window._fbCollection || !window._fbOnSnapshot) {
    callback([]);
    return () => {};
  }
  return window._fbOnSnapshot(
    window._fbCollection(db, 'propostas'),
    snap => {
      const list = [];
      snap.forEach(d => list.push({ id: d.id, ...d.data() }));
      list.sort((a, b) => msOf(b.criadoEm) - msOf(a.criadoEm));
      callback(list);
    },
    () => callback([]),
  );
}

/**
 * Id de proposta gerado NO NAVEGADOR, sem ida ao servidor (`doc(coleção)` do Firestore).
 *
 * (21/09) O rascunho automático do construtor precisa saber o id no mesmo instante em que
 * pede a gravação: é por ele que o «Salvar» seguinte atualiza o MESMO documento em vez de
 * criar um segundo. Com `addDoc` o id só chegava quando o servidor respondesse — e, sem
 * internet, nunca: o «Salvar» ficaria pendurado esperando.
 */
export function reservarIdDeProposta() {
  return window._fbDoc(window._fbCollection(window._fbDb, 'propostas')).id;
}

export async function createProposta({
  id = '',
  subjectType = 'lead',
  leadId = '',
  clientId = '',
  clientNome = '',
  proposalNo = '',
  versao = 1,
  status = 'rascunho',
  dados,
  criadoPor = '',
}) {
  const db = window._fbDb;
  const docRef = id ? window._fbDoc(db, 'propostas', id) : window._fbDoc(window._fbCollection(db, 'propostas'));
  await window._fbSetDoc(docRef, {
    subjectType,
    leadId,
    clientId,
    clientNome,
    proposalNo,
    versao,
    status,
    dados,
    criadoEm: window._fbServerTimestamp(),
    atualizadoEm: window._fbServerTimestamp(),
    criadoPor,
  });
  return docRef.id;
}

export async function updateProposta(id, { dados, status }) {
  const db = window._fbDb;
  const ref = window._fbDoc(db, 'propostas', id);
  const patch = { atualizadoEm: window._fbServerTimestamp() };
  if (dados !== undefined) patch.dados = dados;
  if (status !== undefined) patch.status = status;
  await window._fbUpdateDoc(ref, patch);
}

export async function deleteProposta(id) {
  const db = window._fbDb;
  await window._fbDeleteDoc(window._fbDoc(db, 'propostas', id));
}
